export default "__VITE_ASSET__b04d5a29__"